module.exports = __webpack_public_path__ + "img/certificate.06d5c62f.svg";